import React, { useContext } from "react";
import { Dropdown, Menu, Icon } from "antd";
import { GlobalContext } from "../../app/providers/GlobalState";

import { perfil } from "../../assets/menu";

export default function DropdownPerfis({ perfis, onPerfilChange }) {
    const globalContext = useContext(GlobalContext);

    function onChangePerfil(perfil) {
        onPerfilChange(perfil);
    }

    const menuPerfis = (
        <Menu>
            {perfis.length > 1 &&
                perfis.map(perfil => (
                    <Menu.Item key={perfil.id} onClick={() => onChangePerfil(perfil)}>
                        {perfil.nome}
                    </Menu.Item>
                ))}
        </Menu>
    );

    const isDropdownAtivo = perfis.length > 1;

    const conteudoPerfil = (
        <span onClick={e => e.preventDefault()} className={`drop-escola ${!isDropdownAtivo ? "not-allow" : ""}`}>
            <div className="icon-perfil">
                <img src={perfil} alt="perfil" />
            </div>
            <span className="escola">Perfil:</span>
            <span className="estabelecimento">{globalContext.perfil?.nome}</span>
            <Icon type="down" style={{ color: "#2D8D87" }} />
        </span>
    );

    return (
        <div className="dropdown-escolas">
            {isDropdownAtivo ? (
                <Dropdown overlay={menuPerfis} trigger={["click"]}>
                    {conteudoPerfil}
                </Dropdown>
            ) : (
                conteudoPerfil
            )}
        </div>
    );
}
